
import Vue from "vue"
import Component from "vue-class-component"
import {date} from "quasar"
import CloseButton from "@/components/CloseButton.vue"
import {Document} from "@/superannuation/memberTypes"

const format = (ds: string) => date.formatDate(ds, "DD/MM/YYYY")

// lists a member's documents (with a download/open action), opened via
// open(docs) from MembersView (e.g. the PDF icon in the members table)
@Component({components: {CloseButton}})
export default class MemberDocumentsDialog extends Vue {
  visible = false
  docs: Array<Document> = []

  readonly docColumns = [
    {name: "name", label: "Document", field: "name", sortable: true},
    {name: "modified", label: "Modified", field: "modified", sortable: true, format},
  ]

  open(docs: Array<Document>) {
    this.docs = docs
    this.visible = true
  }

  private openDocument(url: string) {
    window.open(url, "_blank")
  }
}
